import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getPolicy } from "../lib/api";
import MarkdownBody from "../components/shared/MarkdownBody";
import { SkeletonCard } from "../components/shared/Skeleton";
import ErrorBanner from "../components/shared/ErrorBanner";
import { t } from "../lib/i18n";

export default function Policy() {
  const { slug } = useParams();
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    (async () => {
      try {
        const data = await getPolicy(slug);
        if (!cancelled) setPolicy(data);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return (
    <section
      data-testid="policy-page"
      className="mx-auto max-w-3xl px-5 pt-20 pb-24 sm:px-6 sm:pt-28"
    >
      <Link
        to="/"
        className="text-xs uppercase tracking-[0.28em] text-[#1A1A1A]/55 transition hover:text-[#C8A24B]"
      >
        ← {t("nav.home")}
      </Link>

      {loading ? (
        <div className="mt-8">
          <SkeletonCard />
        </div>
      ) : error || !policy ? (
        <div className="mt-8">
          <ErrorBanner message="Policy not found." />
        </div>
      ) : (
        <article className="mt-8">
          <p className="text-xs uppercase tracking-[0.32em] text-[#C8A24B]">
            ShutterKART legal
          </p>
          <h1
            data-testid="policy-title"
            className="mt-3 font-display text-4xl text-[#1A1A1A] sm:text-5xl"
          >
            {policy.title}
          </h1>
          {policy.updated_at ? (
            <p className="mt-2 text-xs uppercase tracking-[0.22em] text-[#1A1A1A]/45">
              Last updated: {String(policy.updated_at).slice(0, 10)}
            </p>
          ) : null}
          <div data-testid="policy-body" className="mt-8">
            <MarkdownBody>{policy.body_markdown || policy.body || ""}</MarkdownBody>
          </div>
        </article>
      )}
    </section>
  );
}
